(function () {
  'use strict';

  /* @ngdoc object
   * @name fuelBurnDiscrepancy
   * @description
   *
   */
  angular
    .module('fuelBurnDiscrepancy', [
      'ui.router'
    ]);
}());
